import styled from 'styled-components'

export const Container = styled.div<{ draggable?: boolean; selected?: boolean; isDragging?: boolean }>`
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: 8px;

  padding: 10px;
  box-sizing: border-box;

  border-radius: 6px;
  background: var(--persistent-white, #fff);

  /* Raised */
  box-shadow: 0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 2px 3px 0px rgba(0, 0, 0, 0.1);

  border: 2px solid ${({ selected }) => (selected ? 'var(--border-primary, #4d4be7)' : '#fff')};

  &.list,
  &.calendar {
    cursor: ${({ isDragging, draggable }) => (isDragging ? 'grabbing' : draggable ? 'grab' : 'pointer')};

    div,
    label,
    img {
      cursor: ${({ isDragging, draggable }) => (isDragging ? 'grabbing' : draggable ? 'grab' : 'pointer')};
    }
  }
`

export const LabelSequenceTemplate = styled.label`
  width: 100%;
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;

  color: var(--foreground-neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 78.571% */
`

export const ResumeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 8px;
`

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`

export const ValueLabel = styled.div`
  color: var(--foreground-neutral-faded, #4d5874);

  /* Caption 1/Regular */
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
`

export const IconImg = styled.img`
  width: 12px;
  height: 12px;
`
